export default "__VITE_ASSET__DoKLNloU__"